module.exports = __webpack_public_path__ + "./Susan_4bc363188a05e94c28716e5e2d6ab1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Susan.jpg
// module id = 542
// module chunks = 0